import classNames from 'classnames';

import Button, {
  Props as ButtonProps
} from '../../Atoms/Button';

interface Props {
  inputPlaceholder?: string;
  button?: ButtonProps;
  mobileButton?: ButtonProps;
  className?: string;
}

function FormSearch({
  inputPlaceholder = 'Zoek een vacature',
  button,
  mobileButton,
  className
}: Props) {
  return (
    <form
      action="#!"
      className={classNames([
        'relative flex w-full flex-col items-center justify-center',
        className
      ])}
    >
      <input
        type="text"
        className={classNames([
          'w-full truncate rounded-xl py-[13px] px-4 pr-14 text-sm outline-0 placeholder:text-sl-blue placeholder:duration-300 focus:placeholder:opacity-0 md:py-3.5 md:pr-32 md:text-base'
        ])}
        placeholder={inputPlaceholder}
      />
      <div className="absolute top-0 right-0 flex h-full items-stretch justify-center">
        <div
          className={classNames([
            mobileButton && 'hidden md:flex',
            !mobileButton && 'flex'
          ])}
        >
          <Button {...button} type="submit" />
        </div>
        {mobileButton && (
          <div className="md:hidden">
            <Button {...mobileButton} type="submit" />
          </div>
        )}
      </div>
    </form>
  );
}

export default FormSearch;
